import React, { useState, useEffect } from "react";
import Header from "../Components/header";
import { useParams, Link } from "react-router-dom";
import { verifyLogin } from "./api";
import Sidebar from "../Components/sidebar";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  gql,
} from "@apollo/client";

const API_KEY =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MTYxOTQ4MDEsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vdjIvY2x3ZXEybTZhMDAwMDAxdzY3YXF6ZWg3eC9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vIiwic3ViIjoiZWYwZWJjYjEtM2IwNi00NjQ2LWFiNTItMWQwMmVlMzJmNzZmIiwianRpIjoiY2tsdXpicmxwNW9sOTAxeHY3MzI1OHRqZCJ9.j6_FyV0D25iUBrQB5EgA_e0IM-ABoTBW8E2lst5jNpC7jpkoefd98lxsIArNC4aM6E5_9MDUDF3aBZpE2vhQv8L0MXwwehcg4cyRJgZ8Ve9tTzLH5ZmZnMdN9L2EsuNxoZ9KHb50VT3-6sBHphWuXun-ufIQovt3p_WG_Fbs6X9exukEHW46y2B0YGM6D-h49g3PWg4YIcPcKoU2AOzk4LHFewzKzqvkaekAj0SZXxTIfqhpfvjafqhDKVUjTqcpo9TrGXuR7Mj8t0skdQg-p9LEHQ6StY3OjRS7iZt9EuQg21iG1A6--_m7PniC70kx494Y_CjsQvaEb3noHgav0XT5qRDVX_sru1zPLG12e-xcMPIceIej40E9oyN4HXETQn9I5zuDj7o6Fnqa8anIaf21C52qVEfD7XTOjC9ug9RwEb5Ix2r404SMNL8V5pKn81WsDE3tziYvfqm3nEf9NYSWASsVsidr_SGUFt6oGJIFF_D25jQtpnwjLpWytN7KrsG8T3t6SHa1rtGh2wf9WEaetA6qARUBJawgZD6TPNUTj7vflkzwNYFFM4dHNpaJj-tBUcTOcsutd_FLSLu5zLkbkFlDdyTUasSZGM_pZqeREHdpvKL8OZbIVSjt_NzxQp2aF3mHyQafE5PuZtjnlZBLkzmTUMa8Rf8FKtIKdIU"; // Sostituisci con la tua API key

const client = new ApolloClient({
  uri: "https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/clweq2m6a000001w67aqzeh7x/master",
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${API_KEY}`,
  },
});

// Definisci la query GraphQL
const DRAFT_QUERY = gql`
  query MyQuery {
    rivistes(orderBy: dataPubblicazione_DESC, stage: DRAFT) {
      id
      numeroRivista
      prezzo
      slugRivista
      updatedAt
      publishedAt
      copertina {
        fileName
        id
        url
      }
    }
  }
`;

const PUBLISHED_QUERY = gql`
  query MyQuery {
    rivistes(orderBy: dataPubblicazione_DESC, stage: PUBLISHED) {
      id
      numeroRivista
      prezzo
      slugRivista
      updatedAt
      publishedAt
      copertina {
        fileName
        id
        url
      }
    }
  }
`;

const AdminRiviste = () => {
  const [error, setError] = useState(null);
  const { slug } = useParams();
  const [isAdmin, setIsAdmin] = useState(false);
  const [riviste, setRiviste] = useState([]);

  // Usa la query di Apollo per ottenere le riviste
  const {
    loading: loadingDraft,
    data: dataDraft,
    error: errorDraft,
  } = useQuery(DRAFT_QUERY, { fetchPolicy: "no-cache" });

  const {
    loading: loadingPublished,
    data: dataPublished,
    error: errorPublished,
  } = useQuery(PUBLISHED_QUERY, { fetchPolicy: "no-cache" });

  useEffect(() => {
    if (dataDraft) {
      setRiviste(dataDraft.rivistes);
    } else if (dataPublished) {
      setRiviste(dataPublished.rivistes);
    }
  }, [dataDraft, dataPublished]);

  useEffect(() => {
    const checkUser = async () => {
      const loggedIn = await verifyLogin();
      if (loggedIn.user) {
        if (loggedIn.user.ruolo === "admin") {
          setIsAdmin(true);
        } else {
          setError("Non hai accesso a questa pagina.");
        }
      } else {
        setError("Non hai accesso a questa pagina.");
      }
    };
    checkUser();
  }, []);

  useEffect(() => {
    if (dataDraft && dataPublished) {
      console.log("DRAFT:", dataDraft);
      console.log("PUBLISHED:", dataPublished);

      // Verifica se il numero di riviste è diverso
      const draftCount = dataDraft.rivistes.length;
      const publishedCount = dataPublished.rivistes.length;
      console.log(draftCount, publishedCount);

      if (draftCount !== publishedCount) {
        console.warn(
          "Il numero di riviste in bozza non corrisponde a quello pubblicato"
        );
        //return;
      }

      // Loop attraverso le riviste in bozza e pubblicate
      for (let i = 0; i < Math.min(draftCount, publishedCount); i++) {
        const draft = dataDraft.rivistes[i];
        const published = dataPublished.rivistes[i];

        console.log(`DRAFT ID ${i}:`, draft.id);

        console.log("QUI");

        if (draft.updatedAt < published.publishedAt) {
          console.log(`La rivista ${draft.numeroRivista} è stata pubblicata.`);
          // setMessage("Il prodotto è stato pubblicato.");
          setRiviste((prevRiviste) => {
            const newRiviste = [...prevRiviste];
            newRiviste[i].published = true;
            return newRiviste;
          });
        } else {
          console.log(
            `La rivista ${draft.numeroRivista} non è stata pubblicata.`
          );
          setRiviste((prevRiviste) => {
            const newRiviste = [...prevRiviste];
            newRiviste[i].published = false;
            return newRiviste;
          });
          // setMessage("Il prodotto non è stato pubblicato.");
          // setIsPublished(false);
        }
        console.log(riviste);
      }
    }
  }, [dataDraft, dataPublished]);

  if (loadingDraft || loadingPublished) {
    return (
      <div className="container mx-auto mt-4">
        <p>Caricamento in corso...</p>
      </div>
    );
  }

  if (error || errorDraft || errorPublished) {
    return (
      <div className="container mx-auto mt-4">
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <span>
            {error ||
              errorDraft ||
              errorPublished ||
              "Si è verificato un errore nel caricamento delle riviste."}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="flex min-h-screen">
        {/* Sidebar */}
        <Sidebar />
        <div className="flex-1 p-6 bg-gray-100">
          <h1 className="text-3xl font-bold mb-6">Gestione riviste</h1>
          <div className="grid sm:grid-cols-2 gap-4 md:grid-cols-5">
            <Link to={`/admin/riviste/nuova-rivista`}>
              <div className="flex flex-col p-4 rounded items-center mt-4">
                <div
                  className="flex items-center justify-center w-full h-auto bg-gray-300 mx-auto max-w-full hover:scale-110 transition duration-500 ease-in-out relative"
                  style={{
                    maxHeight: "240px",
                    maxWidth: "180px",
                    minHeight: "90px",
                    minWidth: "90px",
                    aspectRatio: "3/4",
                  }}
                >
                  <div className="absolute w-[70%] h-2 rounded-3xl rotate-90 bg-gray-400"></div>
                  <div className="absolute w-[70%] h-2 rounded-3xl rotate-0 bg-gray-400"></div>
                </div>
              </div>
            </Link>
            {riviste.length > 0 ? (
              riviste.map((rivista) => (
                <Link
                  key={rivista.id}
                  to={`/admin/riviste/${rivista.slugRivista}`}
                  className="text-center mt-4"
                >
                  <div
                    className={`flex flex-col p-4 rounded items-center ${
                      !rivista.published
                        ? "bg-red-100 border border-red-400"
                        : ""
                    }`}
                    style={{
                      borderRadius: !rivista.published ? "0.5rem" : "none",
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    <img
                      src={rivista.copertina.url}
                      alt={rivista.copertina.fileName}
                      className="w-full h-auto mx-auto max-w-full hover:scale-110 transition duration-500 ease-in-out"
                      style={{
                        maxHeight: "240px",
                        maxWidth: "180px",
                        minHeight: "90px",
                        minWidth: "90px",
                      }}
                      onError={(e) => {
                        e.target.src = "/path-to-default-image.jpg";
                      }}
                    />
                    <p className="font-bold mt-4">{rivista.numeroRivista}</p>
                    <p className="font-bold text-gray-600 mt-2">
                      € {rivista.prezzo}
                    </p>
                    {!rivista.published && (
                      <p className="text-red-500 font-semibold mt-2">
                        Bozza non pubblicata
                      </p>
                    )}
                  </div>
                </Link>
              ))
            ) : (
              <p>Nessuna rivista disponibile.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <ApolloProvider client={client}>
    <AdminRiviste />
  </ApolloProvider>
);

export default App;
